/* eslint-disable no-undef */
import Web3, { net } from 'web3';
import erc20Abi from '../abi/erc20Abi.json';
import swapAbi from '../abi/swapAbi.json';
import botAbi from '../abi/botAbi.json';
import web3config from '../web3config';
import { getActiveChains } from '../../Action/action';

const validateProvider = async (walletProvider, networkId) => {
  try {
    const chainData = await getActiveChains();
    console.log('Chain Data:', chainData);

    walletProvider = await walletProvider;
    if (!walletProvider) {
      console.log('Wallet provider not found.');
      return {
        status: false,
        message: 'Please connect your web3 wallet',
      };
    }

    const web3 = new Web3(walletProvider);
    const accounts = await walletProvider.request({
      method: 'eth_requestAccounts',
    });

    if (!accounts || accounts.length === 0) {
      return {
        status: false,
        message: 'No accounts found. Please connect your wallet.',
      };
    }

    const currentChainId = await web3.eth.getChainId();
    console.log(
      'Connected Accounts:',
      accounts,
      'Current Chain ID:',
      currentChainId
    );

    const networks = chainData.data.map((data) => ({
      chainId: data.chainNetworkId,
      chainName: data.chainName,
      nativeCurrency: {
        name: data.chainName,
        symbol: data.chainSymbol,
        decimals: 18,
      },
      rpcUrls: [data.chainRPCUrl],
      blockExplorerUrls: [data.chainExplorerUrl],
    }));

    if (networkId !== web3.utils.toHex(currentChainId)) {
      try {
        await walletProvider.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: networkId }],
        });
      } catch (switchError) {
        if (switchError.code === 4902 || switchError.code === 32603) {
          const networkToAdd = networks.find(
            (net) => net.chainId === networkId
          );
          //console.log('neeettttttt',networkToAdd)

          if (networkToAdd) {
            try {
              await walletProvider.request({
                method: 'wallet_addEthereumChain',
                params: [networkToAdd],
              });
            } catch (addError) {
              console.error(`Failed to add network:`, addError);
              return {
                status: false,
                message: `Failed to add the network. Please try again.`,
              };
            }
          } else {
            console.error('Unsupported network:', networkId);
            return {
              status: false,
              message: 'Unsupported network. Please use a supported network.',
            };
          }
        } else {
          console.error('Switch Error:', switchError);
          return {
            status: false,
            message: `Switch Error: ${switchError.message || switchError}`,
          };
        }
      }
    }

    return {
      status: true,
      web3,
      walletProvider,
      accounts,
      chain: currentChainId,
    };
  } catch (error) {
    console.error('Error in validateProvider:', error);
    return {
      status: false,
      message: 'Error in validating provider. Please try again.',
    };
  }
};

// export const NewPool = async (req) => {
//   try {
//     const {
//       walletProvider,
//       pairContractAddress,
//       usdtAddress,
//       usdtAmount,
//       tokenAddress,
//       tokenAmount,
//       networkId,
//     } = req;
//     const validate = await validateProvider(walletProvider, networkId);
//     if (!validate.status) {
//       return validate;
//     }
//     let web3 = validate.web3;
//     let walletAddress = validate.accounts[0];
//     let swapContract = new web3.eth.Contract(swapAbi, pairContractAddress);
//     let usdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);
//     let usdtDecimals = await usdtContract.methods.decimals().call();
//     let tokenContract = new web3.eth.Contract(erc20Abi, tokenAddress);
//     let tokenDecimals = await tokenContract.methods.decimals().call();
//     //console.log("dec",usdtDecimals,tokenDecimals)
//     let amountUsdt = (usdtAmount * 10 ** parseInt(usdtDecimals)).toLocaleString(
//       'fullwide',
//       { useGrouping: false }
//     );
//     let amountToken = (
//       tokenAmount *
//       10 ** parseInt(tokenDecimals)
//     ).toLocaleString('fullwide', { useGrouping: false });

//     let isExists = await swapContract.methods
//       .doesTokenUsdtPoolExists(tokenAddress)
//       .call();
//     if (isExists) {
//       return {
//         message: 'Pool already exist',
//       };
//     }

//     let trx = await swapContract.methods.createPool(
//       tokenAddress,
//       amountToken,
//       amountUsdt
//     );

//     let gasPrice = await web3.eth.getGasPrice();
//     let gasLimit = await web3.eth.estimateGas({
//       gasPrice: web3.utils.toHex(gasPrice),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     const trxData = await web3.eth.sendTransaction({
//       gasPrice: web3.utils.toHex(gasPrice),
//       gas: web3.utils.toHex(gasLimit),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     await web3.eth.currentProvider.request({
//       method: 'eth_sendTransaction',
//       params: [
//         {
//           gasPrice: web3.utils.toHex(gasPrice),
//           gas: web3.utils.toHex(gasLimit),
//           to: pairContractAddress,
//           from: walletAddress,
//           data: trx.encodeABI(),
//         },
//       ],
//     });

//     return {
//       status: true,
//       hash: trxData.transactionHash,
//       message:
//         'Pool created successfully. It will take a few minutes to confirm the transaction.',
//     };
//   } catch (error) {
//     console.log('POOL', error);
//     return {
//       status: false,
//       message: `Error creating pool ${error.toString()}`,
//     };
//   }
// };

export const NewPool = async (req) => {
  try {
    const {
      walletProvider,
      pairContractAddress,
      usdtAddress,
      usdtAmount,
      tokenAddress,
      tokenAmount,
      networkId,
    } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) return validate;

    const web3 = validate.web3;
    const walletAddress = validate.accounts[0];

    const swapContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    const usdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);
    const tokenContract = new web3.eth.Contract(erc20Abi, tokenAddress);

    const usdtDecimals = await usdtContract.methods.decimals().call();
    const tokenDecimals = await tokenContract.methods.decimals().call();

    const usdtAmt =
      (BigInt(Math.floor(usdtAmount * 1e6)) *
        BigInt(10) ** BigInt(usdtDecimals)) /
      BigInt(1e6);
    const tokenAmt =
      (BigInt(Math.floor(tokenAmount * 1e6)) *
        BigInt(10) ** BigInt(tokenDecimals)) /
      BigInt(1e6);

    const isExists = await swapContract.methods
      .doesTokenUsdtPoolExists(tokenAddress)
      .call();

    if (isExists) {
      return {
        status: false,
        message: 'Pool already exists',
      };
    }

    const trx = swapContract.methods.createPool(
      tokenAddress,
      tokenAmt.toString(),
      usdtAmt.toString()
    );

    const baseGasPrice = await web3.eth.getGasPrice();
    const boostedGasPrice = (BigInt(baseGasPrice) * BigInt(110)) / BigInt(100);

    const estimatedGas = await trx.estimateGas({ from: walletAddress });
    const gasLimit = Math.floor(estimatedGas * 1.2); // 20% buffer

    const receipt = await trx.send({
      from: walletAddress,
      gas: gasLimit,
      gasPrice: boostedGasPrice.toString(),
    });

    return {
      status: true,
      hash: receipt.transactionHash,
      message:
        'Pool created successfully. It may take a few minutes to confirm the transaction.',
    };
  } catch (error) {
    console.error('POOL creation error:', error);
    return {
      status: false,
      message: `Error creating pool: ${error.toString()}`,
    };
  }
};

export const ApproveUsdtToken = async (req) => {
  try {
    const {
      walletProvider,
      usdtAddress,
      pairContractAddress,
      usdtAmount,
      networkId,
    } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let erc20Contract = new web3.eth.Contract(erc20Abi, usdtAddress);
    const allowance = await erc20Contract.methods
      .allowance(walletAddress, pairContractAddress)
      .call();
    let decimals = await erc20Contract.methods.decimals().call();
    // eslint-disable-next-line no-undef
    const amount = BigInt(
      Math.floor(parseFloat(usdtAmount) * 10 ** parseInt(decimals))
    );
    if (BigInt(allowance) >= amount) {
      return {
        status: true,
        alreadyApproved: true,
      };
    }
    const trx = erc20Contract.methods.approve(
      pairContractAddress,
      '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
    );
    // let trx = await erc20Contract.methods.approve(pairContractAddress,amount)
    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({ from: walletAddress });
    const trxData = await web3.eth.sendTransaction({
      from: walletAddress,
      to: usdtAddress,
      gas: web3.utils.toHex(gasLimit),
      gasPrice: web3.utils.toHex(gasPrice),
      data: trx.encodeABI(),
    });
    return {
      status: true,
      alreadyApproved: false,
      hash: trxData.transactionHash,
    };
  } catch (error) {
    console.log('Usdt approval error', error);
    return {
      status: false,
      message: `Usdt Approval error: ${error.toString()}`,
    };
  }
};

export const ApproveToken = async (req) => {
  try {
    const {
      walletProvider,
      tokenAddress,
      pairContractAddress,
      tokenAmount,
      networkId,
    } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    const allowance = await erc20Contract.methods
      .allowance(walletAddress, pairContractAddress)
      .call();
    let decimals = await erc20Contract.methods.decimals().call();
    const amount = BigInt(
      Math.floor(parseFloat(tokenAmount) * 10 ** parseInt(decimals))
    );
    if (BigInt(allowance) >= amount) {
      return {
        status: true,
        alreadyApproved: true,
      };
    }
    const trx = erc20Contract.methods.approve(
      pairContractAddress,
      '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff'
    );
    //let trx =  erc20Contract.methods.approve(pairContractAddress, amount)
    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({ from: walletAddress });
    const trxData = await web3.eth.sendTransaction({
      from: walletAddress,
      to: tokenAddress,
      gas: web3.utils.toHex(gasLimit),
      gasPrice: web3.utils.toHex(gasPrice),
      data: trx.encodeABI(),
    });

    return {
      status: true,
      alreadyApproved: false,
      hash: trxData.transactionHash,
    };
  } catch (error) {
    console.log('Approve token error', error);
    return {
      status: false,
      message: `Approve Token error: ${error.toString()}`,
    };
  }
};

// export const AddLiquidity = async (req) => {
//   try {
//     const {
//       walletProvider,
//       pairContractAddress,
//       tokenAddress,
//       tokenAmount,
//       networkId,
//     } = req;
//     const validate = await validateProvider(walletProvider, networkId);
//     if (!validate.status) {
//       return validate;
//     }
//     let web3 = validate.web3;
//     let walletAddress = validate.accounts[0];
//     let pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
//     let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
//     let decimals = await erc20Contract.methods.decimals().call();

//     let amountToken = (tokenAmount * 10 ** parseInt(decimals)).toLocaleString(
//       'fullwide',
//       { useGrouping: false }
//     );
//     //console.log('AAAAAA',amountToken)
//     let isExists = await pairContract.methods
//       .doesTokenUsdtPoolExists(tokenAddress)
//       .call();
//     if (!isExists) {
//       return {
//         status: true,
//         message: 'Pool does not exist',
//       };
//     }

//     let trx = await pairContract.methods.addLiquidity(
//       tokenAddress,
//       amountToken
//     );

//     let gasPrice = await web3.eth.getGasPrice();
//     let gasLimit = await web3.eth.estimateGas({
//       gasPrice: web3.utils.toHex(gasPrice),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     const trxData = await web3.eth.sendTransaction({
//       gasPrice: web3.utils.toHex(gasPrice),
//       gas: web3.utils.toHex(gasLimit),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     return {
//       status: true,
//       hash: trxData.transactionHash,
//       message:
//         'Tokens added to liquidity pool successfully. It will take a few minutes to confirm the transaction.',
//     };
//   } catch (error) {
//     console.log('Error adding Liquidity', error);
//     return {
//       status: false,
//       message: `Error adding liquidity: ${error.toString()}`,
//     };
//   }
// };

export const AddLiquidity = async (req) => {
  try {
    const {
      walletProvider,
      pairContractAddress,
      tokenAddress,
      tokenAmount,
      networkId,
    } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) return validate;

    const web3 = validate.web3;
    const walletAddress = validate.accounts[0];

    const pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    const erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);

    const decimals = await erc20Contract.methods.decimals().call();
    const multiplier = BigInt(10) ** BigInt(decimals);
    const amountToken =
      (BigInt(Math.floor(tokenAmount * 1e6)) * multiplier) / BigInt(1e6);

    const isExists = await pairContract.methods
      .doesTokenUsdtPoolExists(tokenAddress)
      .call();

    if (!isExists) {
      return {
        status: false,
        message: 'Pool does not exist',
      };
    }

    const trx = pairContract.methods.addLiquidity(
      tokenAddress,
      amountToken.toString()
    );

    const baseGasPrice = await web3.eth.getGasPrice();
    const boostedGasPrice =
      (BigInt(baseGasPrice) * BigInt(110n)) / BigInt(100n);

    const estimatedGas = await trx.estimateGas({ from: walletAddress });
    const gasLimit = Math.floor(estimatedGas * 1.2); // 20% buffer

    const receipt = await trx.send({
      from: walletAddress,
      gas: gasLimit,
      gasPrice: boostedGasPrice.toString(),
    });

    return {
      status: true,
      hash: receipt.transactionHash,
      message:
        'Tokens added to liquidity pool successfully. It may take a few minutes to confirm the transaction.',
    };
  } catch (error) {
    console.error('Error adding Liquidity:', error);
    return {
      status: false,
      message: `Error adding liquidity: ${error.toString()}`,
    };
  }
};

// export const RemoveLiquidity = async (req) => {
//   try {
//     const {
//       walletProvider,
//       pairContractAddress,
//       tokenAddress,
//       lpAmount,
//       networkId,
//     } = req;
//     const validate = await validateProvider(walletProvider, networkId);
//     if (!validate.status) {
//       return validate;
//     }
//     let web3 = validate.web3;
//     let walletAddress = validate.accounts[0];
//     let contract = new web3.eth.Contract(swapAbi, pairContractAddress);
//     let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
//     let decimals = await erc20Contract.methods.decimals().call();

//     let amountLp = (lpAmount * 10 ** parseInt(decimals)).toLocaleString(
//       'fullwide',
//       { useGrouping: false }
//     );

//     let isExists = await contract.methods
//       .doesTokenUsdtPoolExists(tokenAddress)
//       .call();
//     if (!isExists) {
//       return {
//         status: true,
//         message: 'Pool does not exist',
//       };
//     }

//     let trx = await contract.methods.removeLiquidity(tokenAddress, amountLp);

//     let gasPrice = await web3.eth.getGasPrice();
//     let gasLimit = await web3.eth.estimateGas({
//       gasPrice: web3.utils.toHex(gasPrice),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     const trxData = await web3.eth.sendTransaction({
//       gasPrice: web3.utils.toHex(gasPrice),
//       gas: web3.utils.toHex(gasLimit),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     return {
//       status: true,
//       hash: trxData.transactionHash,
//       message:
//         'Tokens removed from liquidity pool successfully. It will take a few minutes to confirm the transaction.',
//     };
//   } catch (error) {
//     console.log('Error removing liquidty', error);
//     return {
//       status: false,
//       message: `Error reemoving Liquidity: ${error.toString()}`,
//     };
//   }
// };

export const RemoveLiquidity = async (req) => {
  try {
    const {
      walletProvider,
      pairContractAddress,
      tokenAddress,
      lpAmount,
      networkId,
    } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) return validate;

    const web3 = validate.web3;
    const walletAddress = validate.accounts[0];

    const contract = new web3.eth.Contract(swapAbi, pairContractAddress);
    const erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);

    const decimals = await erc20Contract.methods.decimals().call();
    const multiplier = BigInt(10) ** BigInt(decimals);
    const amountLp =
      (BigInt(Math.floor(lpAmount * 1e6)) * multiplier) / BigInt(1e6);

    const isExists = await contract.methods
      .doesTokenUsdtPoolExists(tokenAddress)
      .call();

    if (!isExists) {
      return {
        status: false,
        message: 'Pool does not exist',
      };
    }

    const trx = contract.methods.removeLiquidity(
      tokenAddress,
      amountLp.toString()
    );

    const baseGasPrice = await web3.eth.getGasPrice();
    const boostedGasPrice = (BigInt(baseGasPrice) * BigInt(110)) / BigInt(100);

    const estimatedGas = await trx.estimateGas({ from: walletAddress });
    const gasLimit = Math.floor(estimatedGas * 1.2); // 20% buffer

    const receipt = await trx.send({
      from: walletAddress,
      gas: gasLimit,
      gasPrice: boostedGasPrice.toString(),
    });

    return {
      status: true,
      hash: receipt.transactionHash,
      message:
        'Tokens removed from liquidity pool successfully. It may take a few minutes to confirm the transaction.',
    };
  } catch (error) {
    console.error('Error removing liquidity', error);
    return {
      status: false,
      message: `Error removing liquidity: ${error.toString()}`,
    };
  }
};

// export const ReceivableUsdt = async (req) => {
//   try {
//     let {
//       tokenAmount,
//       pairContractAddress,
//       walletProvider,
//       tokenAddress,
//       networkId,
//     } = req;
//     const validate = await validateProvider(walletProvider, networkId);
//     if (!validate.status) {
//       return validate;
//     }
//     let web3 = validate.web3;
//     let walletAddress = validate.accounts[0];
//     let pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
//     let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
//     let decimals = await erc20Contract.methods.decimals().call();

//     let amountToken = (tokenAmount * 10 ** parseInt(decimals)).toLocaleString(
//       'fullwide',
//       { useGrouping: false }
//     );

//     let result = await pairContract.methods
//       .expectedUsdtToReceive(tokenAddress, amountToken)
//       .call();
//     //console.log('answer',result)
//     if (networkId == web3config.ChaiIdBinance) {
//       return [
//         {
//           staus: true,
//           data: {
//             AmountToSbse: Number(result.amountToSbse) / 10 ** 18, //
//             BuyBack: Number(result.returnAmountInUsdt) / 10 ** 18,
//             ToTreasuryOrPool: Number(result.toTreasuryOrPoolInUsdt) / 10 ** 18,
//             SbSeReserve: Number(result.reserveAmt) / 10 ** 18,
//             USDT: Number(result.actualUsdt) / 10 ** 18,
//           },
//         },
//       ];
//     } else {
//       return [
//         {
//           staus: true,
//           data: {
//             AmountToSbse: Number(result.amountToSbse) / 10 ** 6,
//             BuyBack: Number(result.returnAmountInUsdt) / 10 ** 6,
//             ToTreasuryOrPool: Number(result.toTreasuryOrPoolInUsdt) / 10 ** 6,
//             SbSeReserve: Number(result.reserveAmt) / 10 ** 6,
//             USDT: Number(result.actualUsdt) / 10 ** 6,
//           },
//         },
//       ];
//     }
//   } catch (error) {
//     console.error('Error getting expected usdt', error);
//   }
// };

// export const SwapTokenToUsdt = async (req) => {
//   try {
//     let {
//       walletProvider,
//       pairContractAddress,
//       tokenAddress,
//       tokenAmount,
//       networkId,
//       toTreasury,
//       usdtAddress,
//     } = req;
//     const validate = await validateProvider(walletProvider, networkId);
//     if (!validate.status) {
//       return validate;
//     }
//     let web3 = validate.web3;
//     let walletAddress = validate.accounts[0];

//     let swapContract = new web3.eth.Contract(swapAbi, pairContractAddress);
//     let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
//     let decimals = await erc20Contract.methods.decimals().call();

//     let usdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);
//     let usdtDecimals = await usdtContract.methods.decimals().call();

//     let amountToken = (tokenAmount * 10 ** parseInt(decimals)).toLocaleString(
//       'fullwide',
//       { useGrouping: false }
//     );

//     let isExists = await swapContract.methods
//       .doesTokenUsdtPoolExists(tokenAddress)
//       .call();
//     if (!isExists) {
//       return {
//         message: 'Pool does not exist',
//       };
//     }
//     let trx = await swapContract.methods.swapTokenToUsdt(
//       tokenAddress,
//       amountToken,
//       toTreasury
//     );

//     let gasPrice = await web3.eth.getGasPrice();
//     let gasLimit = await web3.eth.estimateGas({
//       gasPrice: web3.utils.toHex(gasPrice),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     const trxData = await web3.eth.sendTransaction({
//       gasPrice: web3.utils.toHex(gasPrice),
//       gas: web3.utils.toHex(gasLimit),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     return {
//       status: true,
//       hash: trxData.transactionHash,
//       message:
//         'Tokens swapped succcessfully.It will take a few minutes to confirm the transaction ',
//     };
//   } catch (error) {
//     console.log('token to usdt swap error', error);
//     return {
//       status: false,
//       message: `Token to Usdt swap error: ${error.toString()}`,
//     };
//   }
// };

export const ReceivableUsdt = async (req) => {
  try {
    const {
      tokenAmount,
      pairContractAddress,
      walletProvider,
      tokenAddress,
      networkId,
    } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) return validate;

    const web3 = validate.web3;
    const walletAddress = validate.accounts[0];
    const pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    const tokenContract = new web3.eth.Contract(erc20Abi, tokenAddress);

    const decimals = await tokenContract.methods.decimals().call();
    const multiplier = BigInt(10) ** BigInt(decimals);
    const tokenAmt =
      (BigInt(Math.floor(tokenAmount * 1e6)) * multiplier) / BigInt(1e6);

    const result = await pairContract.methods
      .expectedUsdtToReceive(tokenAddress, tokenAmt.toString())
      .call();

    const divisor = networkId == web3config.ChaiIdBinance ? 1e18 : 1e6;

    return [
      {
        status: true,
        data: {
          AmountToSbse: Number(result.amountToSbse) / divisor,
          BuyBack: Number(result.returnAmountInUsdt) / divisor,
          ToTreasuryOrPool: Number(result.toTreasuryOrPoolInUsdt) / divisor,
          SbSeReserve: Number(result.reserveAmt) / divisor,
          USDT: Number(result.actualUsdt) / divisor,
        },
      },
    ];
  } catch (error) {
    console.error('Error getting expected USDT:', error);
    return [
      {
        status: false,
        message: `Error getting expected USDT: ${error.toString()}`,
      },
    ];
  }
};

export const SwapTokenToUsdt = async (req) => {
  try {
    const {
      walletProvider,
      pairContractAddress,
      tokenAddress,
      tokenAmount,
      networkId,
      toTreasury,
      usdtAddress,
    } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) return validate;

    const web3 = validate.web3;
    const walletAddress = validate.accounts[0];

    const swapContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    const erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);

    // ✅ Use BigInt for safe arithmetic
    const decimals = await erc20Contract.methods.decimals().call();
    const multiplier = BigInt(10) ** BigInt(decimals);
    const amountToken =
      (BigInt(Math.floor(tokenAmount * 1e6)) * multiplier) / BigInt(1e6);

    // ✅ Check pool existence early
    const isExists = await swapContract.methods
      .doesTokenUsdtPoolExists(tokenAddress)
      .call();

    if (!isExists) {
      return {
        status: false,
        message: 'Pool does not exist',
      };
    }

    const tx = swapContract.methods.swapTokenToUsdt(
      tokenAddress,
      amountToken.toString(),
      toTreasury
    );

    // ✅ Use higher gas price or EIP-1559 model
    const feeData = (await web3.eth.getFeeHistory)
      ? await web3.eth.getFeeHistory(1, 'latest', [50])
      : null;

    const gasPrice = await web3.eth.getGasPrice();
    const boostedGasPrice = (BigInt(gasPrice) * BigInt(110)) / BigInt(100); // +10%

    // ✅ Add gas buffer
    const estimatedGas = await tx.estimateGas({
      from: walletAddress,
    });

    const gasLimit = Math.floor(estimatedGas * 1.2); // 20% buffer

    // ✅ Prefer using .send over raw sendTransaction for safety
    const receipt = await tx.send({
      from: walletAddress,
      gas: gasLimit,
      gasPrice: boostedGasPrice.toString(),
    });

    return {
      status: true,
      hash: receipt.transactionHash,
      message:
        'Tokens swapped successfully. It may take a few minutes to confirm.',
    };
  } catch (error) {
    console.error('token to usdt swap error', error);
    return {
      status: false,
      message: `Token to Usdt swap error: ${error.toString()}`,
    };
  }
};

// export const ReceivableToken = async (req) => {
//   try {
//     const {
//       usdtAmount,
//       pairContractAddress,
//       walletProvider,
//       usdtAddress,
//       tokenAddress,
//       networkId,
//     } = req;
//     const validate = await validateProvider(walletProvider, networkId);
//     if (!validate.status) {
//       return validate;
//     }

//     let web3 = validate.web3;
//     let walletAddress = validate.accounts[0];

//     let pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
//     let erc20Contract = new web3.eth.Contract(erc20Abi, usdtAddress);
//     let decimals = await erc20Contract.methods.decimals().call();

//     let amountUsdt = (usdtAmount * 10 ** parseInt(decimals)).toLocaleString(
//       'fullwide',
//       { useGrouping: false }
//     );
//     let result = await pairContract.methods
//       .expectedTokenToReceive(tokenAddress, amountUsdt)
//       .call();
//     //     console.log('ANS',result)
//     if (networkId == web3config.ChaiIdBinance) {
//       return [
//         {
//           staus: true,
//           data: {
//             Fees:
//               Number(result.finalFee - result.returnAmountInUsdt) / 10 ** 18,
//             BuyBack: Number(result.returnAmountInUsdt) / 10 ** 18,
//             Token: Number(result.actualTokenToReceive) / 10 ** 18,
//           },
//         },
//       ];
//     } else {
//       return [
//         {
//           staus: true,
//           data: {
//             Fees: Number(result.finalFee - result.returnAmountInUsdt) / 10 ** 6,
//             BuyBack: Number(result.returnAmountInUsdt) / 10 ** 6,
//             Token: Number(result.actualTokenToReceive) / 10 ** 18,
//           },
//         },
//       ];
//     }
//   } catch (error) {
//     console.log('Error getting expected token', error);
//     return [
//       {
//         status: false,
//       },
//     ];
//   }
// };

// export const SwapUsdtToToken = async (req) => {
//   try {
//     const {
//       walletProvider,
//       pairContractAddress,
//       tokenAddress,
//       usdtAddress,
//       usdtAmount,
//       networkId,
//     } = req;
//     //console.log('xxxx',req)
//     const validate = await validateProvider(walletProvider, networkId);
//     if (!validate.status) {
//       return validate;
//     }
//     let web3 = validate.web3;
//     let walletAddress = validate.accounts[0];

//     let swapContract = new web3.eth.Contract(swapAbi, pairContractAddress);
//     let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
//     let UsdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);

//     let tokenDecimals = await erc20Contract.methods.decimals().call();
//     let usdtDecimals = await UsdtContract.methods.decimals().call();

//     let amountUsdt = (usdtAmount * 10 ** parseInt(usdtDecimals)).toLocaleString(
//       'fullwide',
//       { useGrouping: false }
//     );

//     let isExists = await swapContract.methods
//       .doesTokenUsdtPoolExists(tokenAddress)
//       .call();
//     if (!isExists) {
//       return {
//         message: 'Pool does not exist',
//       };
//     }

//     let trx = await swapContract.methods.swapUsdtToToken(
//       tokenAddress,
//       amountUsdt
//     );

//     let gasPrice = await web3.eth.getGasPrice();
//     let gasLimit = await web3.eth.estimateGas({
//       gasPrice: web3.utils.toHex(gasPrice),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     const trxData = await web3.eth.sendTransaction({
//       gasPrice: web3.utils.toHex(gasPrice),
//       gas: web3.utils.toHex(gasLimit),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     return {
//       status: true,
//       hash: trxData.transactionHash,
//       message:
//         'Usdt swapped succcessfully.It will take a few minutes to confirm the transaction ',
//     };
//   } catch (error) {
//     console.log('Usdt to Token swap error', error);
//     return {
//       status: false,
//       message: `Usdt to token swap error: ${error.toString()}`,
//     };
//   }
// };

export const ReceivableToken = async (req) => {
  try {
    const {
      usdtAmount,
      pairContractAddress,
      walletProvider,
      usdtAddress,
      tokenAddress,
      networkId,
    } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) return validate;

    const web3 = validate.web3;
    const walletAddress = validate.accounts[0];

    const pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    const usdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);
    const decimals = await usdtContract.methods.decimals().call();

    const multiplier = BigInt(10) ** BigInt(decimals);
    const amountUsdt =
      (BigInt(Math.floor(usdtAmount * 1e6)) * multiplier) / BigInt(1e6);

    const result = await pairContract.methods
      .expectedTokenToReceive(tokenAddress, amountUsdt.toString())
      .call();

    const divisor = networkId == web3config.ChaiIdBinance ? 1e18 : 1e6;

    return [
      {
        status: true,
        data: {
          Fees:
            (Number(result.finalFee) - Number(result.returnAmountInUsdt)) /
            divisor,
          BuyBack: Number(result.returnAmountInUsdt) / divisor,
          Token: Number(result.actualTokenToReceive) / 1e18, // Assuming token has 18 decimals
        },
      },
    ];
  } catch (error) {
    console.error('Error getting expected token', error);
    return [
      {
        status: false,
        message: `Error getting expected token: ${error.toString()}`,
      },
    ];
  }
};

export const SwapUsdtToToken = async (req) => {
  try {
    const {
      walletProvider,
      pairContractAddress,
      tokenAddress,
      usdtAddress,
      usdtAmount,
      networkId,
    } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) return validate;

    const web3 = validate.web3;
    const walletAddress = validate.accounts[0];

    const swapContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    const usdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);

    // ✅ Only need USDT decimals
    const usdtDecimals = await usdtContract.methods.decimals().call();
    const multiplier = BigInt(10) ** BigInt(usdtDecimals);
    const amountUsdt =
      (BigInt(Math.floor(usdtAmount * 1e6)) * multiplier) / BigInt(1e6);

    // ✅ Validate pool existence early
    const isExists = await swapContract.methods
      .doesTokenUsdtPoolExists(tokenAddress)
      .call();

    if (!isExists) {
      return {
        status: false,
        message: 'Pool does not exist',
      };
    }

    // ✅ Build transaction
    const trx = swapContract.methods.swapUsdtToToken(
      tokenAddress,
      amountUsdt.toString()
    );

    // ✅ Boost gas price by 10% for speed
    const baseGasPrice = await web3.eth.getGasPrice();
    const boostedGasPrice = (BigInt(baseGasPrice) * BigInt(110)) / BigInt(100);

    const estimatedGas = await trx.estimateGas({ from: walletAddress });
    const gasLimit = Math.floor(estimatedGas * 1.2); // 20% buffer

    // ✅ Send transaction with buffer
    const receipt = await trx.send({
      from: walletAddress,
      gas: gasLimit,
      gasPrice: boostedGasPrice.toString(),
    });

    return {
      status: true,
      hash: receipt.transactionHash,
      message:
        'USDT swapped successfully. It may take a few minutes to confirm the transaction.',
    };
  } catch (error) {
    console.error('USDT to Token swap error', error);
    return {
      status: false,
      message: `USDT to Token swap error: ${error.toString()}`,
    };
  }
};

export const getUserUsdtBalance = async (req) => {
  const { usdtAddress, walletProvider, networkId } = req;
  try {
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = await validate.web3;
    let walletAddress = await validate.accounts[0];
    let contract = new web3.eth.Contract(erc20Abi, usdtAddress);
    let balance = await contract.methods.balanceOf(walletAddress).call();

    if (networkId == web3config.ChaiIdBinance) {
      return {
        status: true,
        balance: Number(balance) / 10 ** 18,
      };
    } else {
      return {
        status: true,
        balance: Number(balance) / 10 ** 6,
      };
    }
  } catch (error) {
    console.log('Error getting user usdt balance', error);
    return {
      message: error.toString(),
    };
  }
};

export const getUserTokenBalance2 = async (req) => {
  const { tokenAddress, walletProvider, networkId } = req;
  try {
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = await validate.web3;
    let walletAddress = await validate.accounts[0];
    let contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let balance = await contract.methods.balanceOf(walletAddress).call();
    return {
      status: true,
      balance: Number(balance) / 10 ** 18,
    };
  } catch (error) {
    console.log('Error getting user usdt balance', error);
    return {
      message: error.toString(),
    };
  }
};

export const getUserTokenBalance = async (req) => {
  const { walletProvider, tokenAddress, networkId, walletAddress } = req;
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let erc20Contract = new web3.eth.Contract(
        erc20Abi,
        data[i].token_address
      );
      let balance = await erc20Contract.methods
        .balanceOf(data[i].owner_address)
        .call();
      results.push(Number(balance) / 10 ** 18);
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.log('Error getting user token balance', error);
  }
};

export const getTokenPriceSwap2 = async (req) => {
  const { walletProvider, pairContractAddress, tokenAddress, networkId } = req;
  try {
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let decimals = await erc20Contract.methods.decimals().call();
    let trx = await pairContract.methods
      .getTokenPriceInUsdt(tokenAddress)
      .call();
    let Price =
      Number(trx) /
      10 **
        parseInt(decimals).toLocaleString('fullwide', { useGrouping: false });
    return {
      status: true,
      data: Price,
    };
  } catch (error) {
    console.log('Error getting token price', error);
  }
};

export const getTokenSupplySwap = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let contractToken = new web3.eth.Contract(
        erc20Abi,
        data[i].token_address
      );
      let decimals = await contractToken.methods.decimals().call();
      let trx = await contractToken.methods
        .totalSupply(data[i].token_address)
        .call();
      let Supply =
        Number(trx) /
        10 **
          parseInt(decimals).toLocaleString('fullwide', { useGrouping: false });
      results.push(Supply);
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.error('Error getting token supply', error);
  }
};

export const getTokenStatusSwap = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let pairContract = new web3.eth.Contract(
        swapAbi,
        data[i].pairContractAddress
      );
      let trx = await pairContract.methods
        .tokenPauseStatus(data[i].token_address)
        .call();
      results.push(trx);
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.error('Error getting token price', error);
  }
};

// export const NewPool2 = async (req) => {
//   try {
//     const {
//       walletProvider,
//       pairContractAddress,
//       usdtAddress,
//       tokenAddress,
//       tokenAmount,
//       networkId,
//     } = req;
//     const validate = await validateProvider(walletProvider, networkId);
//     if (!validate.status) {
//       return validate;
//     }
//     let web3 = validate.web3;
//     let walletAddress = validate.accounts[0];
//     let contract = new web3.eth.Contract(swapAbi, pairContractAddress);
//     let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
//     let decimals = await erc20Contract.methods.decimals().call();

//     let amountToken = (tokenAmount * 10 ** parseInt(decimals)).toLocaleString(
//       'fullwide',
//       { useGrouping: false }
//     );

//     let isExists = await contract.methods
//       .doesTokenUsdtPoolExists(tokenAddress)
//       .call();
//     if (isExists) {
//       return {
//         message: 'Pool already exist',
//       };
//     }
//     let trx = await contract.methods.createPool2(tokenAddress, amountToken);

//     let gasPrice = await web3.eth.getGasPrice();
//     let gasLimit = await web3.eth.estimateGas({
//       gasPrice: web3.utils.toHex(gasPrice),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     const trxData = await web3.eth.sendTransaction({
//       gasPrice: web3.utils.toHex(gasPrice),
//       gas: web3.utils.toHex(gasLimit),
//       to: pairContractAddress,
//       from: walletAddress,
//       data: trx.encodeABI(),
//     });

//     return {
//       status: true,
//       hash: trxData.transactionHash,
//       message:
//         'Pool created successfully. It will take a few minutes to confirm the transaction.',
//     };
//   } catch (error) {
//     console.log('Error creating preliquidity pool', error);
//     return {
//       status: false,
//       message: `Error creating preliquidity pool: ${error.toString()}`,
//     };
//   }
// };

export const NewPool2 = async (req) => {
  try {
    const {
      walletProvider,
      pairContractAddress,
      tokenAddress,
      tokenAmount,
      networkId,
    } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) return validate;

    const web3 = validate.web3;
    const walletAddress = validate.accounts[0];
    const contract = new web3.eth.Contract(swapAbi, pairContractAddress);
    const erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    const decimals = await erc20Contract.methods.decimals().call();

    const amountToken = BigInt(tokenAmount * 1e18).toString();

    const isExists = await contract.methods
      .doesTokenUsdtPoolExists(tokenAddress)
      .call();
    if (isExists) {
      return {
        status: false,
        message: 'Pool already exists',
      };
    }

    const trx = contract.methods.createPool2(tokenAddress, amountToken);

    const gasPrice = await web3.eth.getGasPrice();
    const gasLimit = await web3.eth.estimateGas({
      from: walletAddress,
      to: pairContractAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      from: walletAddress,
      to: pairContractAddress,
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      data: trx.encodeABI(),
    });

    return {
      status: true,
      hash: trxData.transactionHash,
      message:
        'Pool created successfully. It will take a few minutes to confirm the transaction.',
    };
  } catch (error) {
    console.error('Error creating preliquidity pool', error);
    return {
      status: false,
      message: `Error creating preliquidity pool: ${error.toString()}`,
    };
  }
};

export const PoolBalances = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let pairContract = new web3.eth.Contract(
        swapAbi,
        data[i].pairContractAddress
      );
      let contractToken = new web3.eth.Contract(
        erc20Abi,
        data[i].token_address
      );
      let tokenDecimals = await contractToken.methods.decimals().call();
      let contractUsdt = new web3.eth.Contract(erc20Abi, data[i].usdtContract);
      let usdtDecimals = await contractUsdt.methods.decimals().call();
      let result = await pairContract.methods
        .getTokenBalances(data[i].token_address)
        .call();
      results.push({
        Token:
          Number(result.tokenABalance) /
          10 **
            parseInt(tokenDecimals).toLocaleString('fullwide', {
              useGrouping: false,
            }),
        USDT:
          Number(result.usdtBalance) /
          10 **
            parseInt(usdtDecimals).toLocaleString('fullwide', {
              useGrouping: false,
            }),
      });
    }
    //console.log('res',results)

    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.log('Error getting pool token balance', error);
  }
};

export const PoolDetails = async (req) => {
  try {
    const { pairContractAddress, walletProvider, tokenAddress, networkId } =
      req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }

    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    let result = await pairContract.methods.getPoolDetails(tokenAddress).call();
    if (networkId == web3config.ChaiIdBinance) {
      return {
        staus: true,
        Owner: result.PoolOwner,
        CurrentTokenPrice: Number(result.tokenPrice) / 10 ** 18,
      };
    } else {
      return {
        staus: true,
        Owner: result.PoolOwner,
        CurrentTokenPrice: Number(result.tokenPrice) / 10 ** 6,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

export const ReceivableAmountAfterRemovingLiquidity = async (req) => {
  try {
    const {
      walletProvider,
      pairContractAddress,
      tokenAddress,
      lpAmount,
      networkId,
    } = req;
    //console.log('xxxx',req)
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];

    let pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    let amount = lpAmount * 10 ** 18;
    let result = await pairContract.methods
      .expectedReturnsAfterRemovingLiquidity(tokenAddress, amount)
      .call();
    if (networkId == web3config.ChaiIdBinance) {
      return {
        status: true,
        data: {
          Token: (Number(result.tokenAReturned) / 10 ** 18).toFixed(18),
          USDT: (Number(result.usdtReturned) / 10 ** 18).toFixed(18),
          PENALTY: (Number(result.penalty) / 10 ** 18).toFixed(18),
        },
      };
    } else {
      return {
        status: true,
        data: {
          Token: (Number(result.tokenAReturned) / 10 ** 18).toFixed(18),
          USDT: (Number(result.usdtReturned) / 10 ** 6).toFixed(6),
          PENALTY: (Number(result.penalty) / 10 ** 6).toFixed(6),
        },
      };
    }
  } catch (error) {
    console.log('Error getting return amount', error);
  }
};

export const LPBalance = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let pairContract = new web3.eth.Contract(
        swapAbi,
        data[i].pairContractAddress
      );
      let result = await pairContract.methods
        .getLPBalance(data[i].token_address)
        .call({ from: data[i].owner_address });
      results.push({
        balance: Number(result) / 10 ** 18,
      });
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.log('Error getting lp token balance', error);
  }
};

export const UsdtAmount2 = async (req) => {
  const {
    walletProvider,
    pairContractAddress,
    tokenAddress,
    tokenAmount,
    networkId,
  } = req;
  try {
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let decimals = await erc20Contract.methods.decimals().call();
    let amountToken = (tokenAmount * 10 ** parseInt(decimals)).toLocaleString(
      'fullwide',
      { useGrouping: false }
    );
    let result = await pairContract.methods
      .getUsdtAmount(tokenAddress, amountToken)
      .call();
    //console.log('net',result)
    if (networkId == web3config.ChaiIdBinance) {
      return {
        status: true,
        Amount: Number(result) / 10 ** 18,
      };
    } else {
      return {
        staus: true,
        Amount: Number(result) / 10 ** 6,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

export const LpToMint = async (req) => {
  try {
    const {
      pairContractAddress,
      walletProvider,
      tokenAddress,
      tokenAmount,
      usdtAddress,
      usdtAmount,
      networkId,
    } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }

    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let UsdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);
    let tokenDecimals = await erc20Contract.methods.decimals().call();
    let usdtDecimals = await UsdtContract.methods.decimals().call();

    let amountToken = (
      tokenAmount *
      10 ** parseInt(tokenDecimals)
    ).toLocaleString('fullwide', { useGrouping: false });
    let amountUsdt = (usdtAmount * 10 ** parseInt(usdtDecimals)).toLocaleString(
      'fullwide',
      { useGrouping: false }
    );

    let result = await pairContract.methods
      .calculateLPTokensToMint(tokenAddress, amountToken, amountUsdt)
      .call();
    return {
      staus: true,
      Bal: Number(result) / 10 ** 18,
    };
  } catch (error) {
    console.log('Error getting lp to mint', error);
  }
};

export const PriceCalculator = async (req) => {
  try {
    const {
      walletProvider,
      usdtAmount,
      pairContractAddress,
      tokenAmount,
      tokenAddress,
      usdtAddress,
      networkId,
    } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }

    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let tokenDecimals = await erc20Contract.methods.decimals().call();
    let UsdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);
    let usdtDecimals = await UsdtContract.methods.decimals().call();

    let amountToken = (
      tokenAmount *
      10 ** parseInt(tokenDecimals)
    ).toLocaleString('fullwide', { useGrouping: false });
    let amountUsdt = (
      tokenAmount *
      10 ** parseInt(usdtDecimals)
    ).toLocaleString('fullwide', { useGrouping: false });

    let result = await pairContract.methods
      .tokenPriceCalculator(amountToken, amountUsdt)
      .call();
    if (networkId == web3config.ChaiIdBinance) {
      return {
        staus: true,
        Price: Number(result) / 10 ** 18,
      };
    } else {
      return {
        staus: true,
        Price: Number(result) / 10 ** 6,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

export const RemovalStatus = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let contractSwap = new web3.eth.Contract(
        swapAbi,
        data[i].pairContractAddress
      );
      let trx = await contractSwap.methods
        .removalStatus(data[i].token_address)
        .call();
      results.push(trx);
    }

    return {
      status: true,
      data: results,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const PoolBalances2 = async (req) => {
  try {
    const {
      pairContractAddress,
      walletProvider,
      tokenAddress,
      usdtAddress,
      networkId,
    } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }

    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let pairContract = new web3.eth.Contract(swapAbi, pairContractAddress);
    let contractToken = new web3.eth.Contract(erc20Abi, tokenAddress);
    let tokenDecimals = await contractToken.methods.decimals().call();
    let contractUsdt = new web3.eth.Contract(erc20Abi, usdtAddress);
    let usdtDecimals = await contractUsdt.methods.decimals().call();
    let result = await pairContract.methods
      .getTokenBalances(tokenAddress)
      .call();
    return {
      status: true,
      data: {
        Token:
          Number(result.tokenABalance) /
          10 **
            parseInt(tokenDecimals).toLocaleString('fullwide', {
              useGrouping: false,
            }),
        USDT:
          Number(result.usdtBalance) /
          10 **
            parseInt(usdtDecimals).toLocaleString('fullwide', {
              useGrouping: false,
            }),
      },
    };
  } catch (error) {
    console.log('Error getting lp token balance', error);
  }
};

export const GetTokenSymbol = async (req) => {
  try {
    const { walletProvider, tokenAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      console.log('Error in provider', validate);
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let decimals = await erc20Contract.methods.decimals().call();
    let total = erc20Contract.methods.totalSupply().call();
    let symbol = erc20Contract.methods.symbol().call();

    return {
      status: true,
      symbol: await symbol,
    };
  } catch (error) {
    return {
      status: false,
      message: error.toString(),
    };
  }
};

export const PoolStatus = async (req) => {
  try {
    const { walletProvider, pairContractAddress, tokenAddress, networkId } =
      req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let contract = new web3.eth.Contract(swapAbi, pairContractAddress);
    let erc20Contract = new web3.eth.Contract(erc20Abi, tokenAddress);
    let decimals = await erc20Contract.methods.decimals().call();

    let isExists = await contract.methods
      .doesTokenUsdtPoolExists(tokenAddress)
      .call();
    return {
      status: isExists,
    };
  } catch (error) {
    console.log('Error getting pool status', error);
    return {
      status: false,
      message: `Error getting pool status': ${error.toString()}`,
    };
  }
};

//bot

export const addBotToken = async (req) => {
  try {
    const { walletProvider, tokenAddress, botWallet, tokenAmount, networkId } =
      req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let tokenContract = new web3.eth.Contract(erc20Abi, tokenAddress);

    let tokenDecimals = await tokenContract.methods.decimals().call();

    let amountToken = (
      tokenAmount *
      10 ** parseInt(tokenDecimals)
    ).toLocaleString('fullwide', { useGrouping: false });

    let balanceToken = await tokenContract.methods
      .balanceOf(walletAddress)
      .call();

    if (parseInt(balanceToken) < parseInt(amountToken)) {
      return {
        status: false,
        message: `Insufficient Token balance`,
      };
    }
    let trx = tokenContract.methods.transfer(botWallet, amountToken);

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: tokenAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      to: tokenAddress,
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      message: 'Tokens Deposited Successfully',
      hash: trxData.transactionHash,
    };
  } catch (error) {
    console.log('Error transferring token to bot', error);
    return {
      status: false,
      message: `Error transferring token to bot': ${error.toString()}`,
    };
  }
};

export const addBotUsdt = async (req) => {
  try {
    const { walletProvider, botWallet, usdtAddress, usdtAmount, networkId } =
      req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let usdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);

    let usdtDecimals = await usdtContract.methods.decimals().call();

    let amountUsdt = (usdtAmount * 10 ** parseInt(usdtDecimals)).toLocaleString(
      'fullwide',
      { useGrouping: false }
    );
    let balanceUsdt = await usdtContract.methods
      .balanceOf(walletAddress)
      .call();

    if (parseInt(balanceUsdt) < parseInt(amountUsdt)) {
      return {
        status: false,
        message: `Insufficient Usdt balance`,
      };
    }

    let trx = usdtContract.methods.transfer(botWallet, amountUsdt);

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: usdtAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      to: usdtAddress,
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      message: 'Usdt Deposited Successfully',
      hash: trxData.transactionHash,
    };
  } catch (error) {
    console.log('Error transferring usdt to bot', error);
    return {
      status: false,
      message: `Error transferring usdt to bot': ${error.toString()}`,
    };
  }
};

export const addBotNative = async (req) => {
  try {
    const { walletProvider, botWallet, nativeAmount, networkId } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }

    const web3 = validate.web3;
    const walletAddress = validate.accounts[0];

    const amountInWei = web3.utils.toWei(nativeAmount.toString(), 'ether');

    const balance = await web3.eth.getBalance(walletAddress);
    if (parseInt(balance) < parseInt(amountInWei)) {
      return {
        status: false,
        message: 'Insufficient native balance',
      };
    }

    await web3.eth.estimateGas({
      from: walletAddress,
      to: botWallet,
      value: amountInWei,
    });

    const tx = await web3.eth.sendTransaction({
      from: walletAddress,
      to: botWallet,
      value: amountInWei,
    });

    return {
      status: true,
      message: 'Native token transfer successful. Bot Started',
      hash: tx.transactionHash,
    };
  } catch (error) {
    console.log('Native transfer error:', error);
    return {
      status: false,
      message: `Native token transfer failed: ${error.message}`,
    };
  }
};

export const removeBotToken = async (req, pvtKey) => {
  try {
    const { walletProvider, tokenAddress, botWallet, tokenAmount, networkId } =
      req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let tokenContract = new web3.eth.Contract(erc20Abi, tokenAddress);

    let tokenDecimals = await tokenContract.methods.decimals().call();

    let amountToken = (
      tokenAmount *
      10 ** parseInt(tokenDecimals)
    ).toLocaleString('fullwide', { useGrouping: false });

    let balanceToken = await tokenContract.methods
      .balanceOf(walletAddress)
      .call();

    if (parseInt(balanceToken) < parseInt(amountToken)) {
      return {
        status: false,
        message: `Insufficient Token balance`,
      };
    }
    let trx = tokenContract.methods.transfer(walletAddress, amountToken);

    let gasPrice = await web3.eth.getGasPrice();
    let nonce = await web3.eth.getTransactionCount(botWallet);
    let gasLimit = await web3.eth.estimateGas({ from: botWallet });

    const trxData = {
      to: tokenAddress,
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      nonce: web3.utils.toHex(nonce),
      data: trx.encodeABI(),
    };
    const signedTrx = await web3.eth.accounts.signTransaction(trxData, pvtKey);
    web3.eth
      .sendSignedTransaction(signedTrx.rawTransaction)
      .on('receipt', (receipt) => console.log('Transfer executed:', receipt))
      .on('error', (error) => console.log('Transfer execution error:', error));

    return {
      status: true,
      message: 'Tokens Withdrawn Successfully',
      hash: trxData.transactionHash,
    };
  } catch (error) {
    console.log('Error transferring token to wallet', error);
    return {
      status: false,
      message: `Error transferring token to wallet': ${error.toString()}`,
    };
  }
};

export const removeBotUsdt = async (req, pvtKey) => {
  try {
    const { walletProvider, botWallet, usdtAddress, usdtAmount, networkId } =
      req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let usdtContract = new web3.eth.Contract(erc20Abi, usdtAddress);
    let usdtDecimals = await usdtContract.methods.decimals().call();

    let amountUsdt = (usdtAmount * 10 ** parseInt(usdtDecimals)).toLocaleString(
      'fullwide',
      { useGrouping: false }
    );
    let balanceUsdt = await usdtContract.methods.balanceOf(botWallet).call();

    if (parseInt(balanceUsdt) < parseInt(amountUsdt)) {
      return {
        status: false,
        message: `Insufficient Usdt balance`,
      };
    }

    let trx = usdtContract.methods.transfer(walletAddress, amountUsdt);

    let gasPrice = await web3.eth.getGasPrice();
    let nonce = await web3.eth.getTransactionCount(botWallet);
    let gasLimit = await web3.eth.estimateGas({ from: botWallet });

    const trxData = {
      to: usdtAddress,
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      nonce: web3.utils.toHex(nonce),
      data: trx.encodeABI(),
    };
    const signedTrx = await web3.eth.accounts.signTransaction(trxData, pvtKey);
    web3.eth
      .sendSignedTransaction(signedTrx.rawTransaction)
      .on('receipt', (receipt) => console.log('Transfer executed:', receipt))
      .on('error', (error) => console.log('Transfer execution error:', error));

    return {
      status: true,
      message: 'Usdt Withdrawn Successfully',
      hash: trxData.transactionHash,
    };
  } catch (error) {
    console.log('Error transferring usdt to wallet', error);
    return {
      status: false,
      message: `Error transferring usdt to wallet': ${error.toString()}`,
    };
  }
};

// export const removeBotNative = async (req,pvtKey) => {
//   try {
//     const { walletProvider, botWallet, nativeAmount, networkId } = req;

//     const validate = await validateProvider(walletProvider, networkId);
//     if (!validate.status) {
//       return validate;
//     }

//     const web3 = validate.web3;
//     const walletAddress = validate.accounts[0];

//     const gasPrice = await web3.eth.getGasPrice();
//     const estimatedGas = 21000;
//     const gasCost = web3.utils.toBigInt(gasPrice).mul(web3.utils.toBigInt(estimatedGas))

//     const balance = await web3.eth.getBalance(botWallet);
//     const balanceBN = web3.utils.toBigInt(balance);

//     const amountInWei = web3.utils.toBigInt(web3.utils.toWei(nativeAmount.toString(), 'ether'));

//     if (balanceBN <= gasCost) {
//       return {
//         status: false,
//         message: 'Insufficient balance to cover gas cost.',
//       };
//     }

//     const maxTransferable = balanceBN - gasCost;
//     const transferAmount = amountInWei > maxTransferable ? maxTransferable : amountInWei;
//     let nonce = await web3.eth.getTransactionCount(botWallet);

//     const tx = {
//       to: walletAddress,
//       value: transferAmount.toString(),
//       gas: estimatedGas,
//       gasPrice,
//       nonce
//     };
//     const signedTrx = await web3.eth.accounts.signTransaction(tx,pvtKey);
//     web3.eth.sendSignedTransaction(signedTrx.rawTransaction).on('receipt', (receipt) => console.log('Transfer executed:', receipt)).on('error', (error) =>console.log('Transfer execution error:', error));

//     return {
//       status: true,
//       message: 'Withdraw successful.',
//       hash: tx.transactionHash,
//     };

//   } catch (error) {
//     console.log('Native transfer to wallet error:', error);
//     return {
//       status: false,
//       message: `Native token transfer to wallet failed: ${error.message}`,
//     };
//   }
// };

export const removeBotNative = async (req, pvtKey) => {
  try {
    const { walletProvider, botWallet, nativeAmount, networkId } = req;

    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) return validate;

    const web3 = validate.web3;
    const walletAddress = validate.accounts[0];

    const gasPrice = await web3.eth.getGasPrice();
    const estimatedGas = 21000;
    const gasCost =
      web3.utils.toBigInt(gasPrice) * web3.utils.toBigInt(estimatedGas);

    const balance = await web3.eth.getBalance(botWallet);
    const balanceBN = web3.utils.toBigInt(balance);

    const amountInWei = web3.utils.toBigInt(
      web3.utils.toWei(nativeAmount.toString(), 'ether')
    );

    if (balanceBN <= gasCost) {
      return {
        status: false,
        message: 'Insufficient balance to cover gas cost.',
      };
    }

    const maxTransferable = balanceBN - gasCost;
    const transferAmount =
      amountInWei > maxTransferable ? maxTransferable : amountInWei;

    const nonce = await web3.eth.getTransactionCount(botWallet);

    const tx = {
      to: walletAddress,
      value: transferAmount.toString(),
      gas: estimatedGas,
      gasPrice,
      nonce,
      chainId: networkId,
    };

    const signedTx = await web3.eth.accounts.signTransaction(tx, pvtKey);
    const receipt = await web3.eth.sendSignedTransaction(
      signedTx.rawTransaction
    );

    return {
      status: true,
      message: 'Native token withdrawn successfully.',
      hash: receipt.transactionHash,
    };
  } catch (error) {
    console.log('Native transfer to wallet error:', error);
    return {
      status: false,
      message: `Native token transfer to wallet failed: ${error.message}`,
    };
  }
};

export const haltBot = async (req) => {
  try {
    const { walletProvider, tokenAddress, botAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    console.log('waa', walletAddress);
    let botContract = new web3.eth.Contract(botAbi, botAddress);

    let isHalted = await botContract.methods.getBotStatus(tokenAddress).call();
    if (isHalted) {
      return {
        //status: true,
        message: 'Bot not active',
      };
    }

    let trx = botContract.methods.haltTrading(tokenAddress);

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: botAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      to: botAddress,
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      message: 'Bot halted Successfully',
      hash: trxData.transactionHash,
    };
  } catch (error) {
    console.log('Error halting Bot', error);
    return {
      status: false,
      message: `Error halting Bot': ${error.toString()}`,
    };
  }
};

export const resumeBot = async (req) => {
  try {
    const { walletProvider, tokenAddress, botAddress, networkId } = req;
    const validate = await validateProvider(walletProvider, networkId);
    if (!validate.status) {
      return validate;
    }
    let web3 = validate.web3;
    let walletAddress = validate.accounts[0];
    let botContract = new web3.eth.Contract(botAbi, botAddress);

    let isHalted = await botContract.methods.getBotStatus(tokenAddress).call();
    console.log('hal', isHalted);
    if (!isHalted) {
      return {
        //status: true,
        message: 'Bot already active',
      };
    }

    let trx = botContract.methods.restartTrading(tokenAddress);

    let gasPrice = await web3.eth.getGasPrice();
    let gasLimit = await web3.eth.estimateGas({
      gasPrice: web3.utils.toHex(gasPrice),
      to: botAddress,
      from: walletAddress,
      data: trx.encodeABI(),
    });

    const trxData = await web3.eth.sendTransaction({
      to: botAddress,
      gasPrice: web3.utils.toHex(gasPrice),
      gas: web3.utils.toHex(gasLimit),
      from: walletAddress,
      data: trx.encodeABI(),
    });

    return {
      status: true,
      message: 'Bot Resumed',
      hash: trxData.transactionHash,
    };
  } catch (error) {
    console.log('Error Resuming Bot', error);
    return {
      status: false,
      message: `Error Resuming Bot': ${error.toString()}`,
    };
  }
};

export const getBotTokenBalance = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      if (!data[i].bot_token_address || !data[i].bot_wallet_address) {
        results.push(null);
        continue;
      }
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let erc20Contract = new web3.eth.Contract(
        erc20Abi,
        data[i].bot_token_address
      );
      let balance = await erc20Contract.methods
        .balanceOf(data[i].bot_wallet_address)
        .call();
      results.push(Number(balance) / 10 ** 18);
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.log('Error getting bot token balance', error);
  }
};

export const getBotUsdtBalance = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      if (!data[i].usdtContract || !data[i].bot_wallet_address) {
        results.push(null);
        continue;
      }
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let erc20Contract = new web3.eth.Contract(erc20Abi, data[i].usdtContract);
      let usdtDecimals = await erc20Contract.methods.decimals().call();
      let balance = await erc20Contract.methods
        .balanceOf(data[i].bot_wallet_address)
        .call();
      results.push(Number(balance) / 10 ** parseInt(usdtDecimals));
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.log('Error getting bot token balance', error);
  }
};

export const getBotNativeBalance = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      if (!data[i].bot_wallet_address) {
        results.push(null);
        continue;
      }
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let balance = await web3.eth.getBalance(data[i].bot_wallet_address);
      results.push(Number(balance) / 10 ** 18);
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.log('Error getting bot token balance', error);
  }
};

export const getBotFee = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      if (!data[i].usdtContract) {
        results.push(null);
        continue;
      }
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let botContract = new web3.eth.Contract(botAbi, data[i].botContract);
      let erc20Contract = new web3.eth.Contract(erc20Abi, data[i].usdtContract);
      let usdtDecimals = await erc20Contract.methods.decimals().call();
      let fee = await botContract.methods.getBotFee().call();
      results.push(Number(fee) / 10 ** parseInt(usdtDecimals));
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.log('Error getting bot token balance', error);
  }
};

export const getBotStatus = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let botContract = new web3.eth.Contract(botAbi, data[i].botContract);
      let stat = await botContract.methods
        .getBotStatus(data[i].token_address)
        .call();
      results.push(stat);
    }
    return {
      data: results,
    };
  } catch (error) {
    console.log('Error getting bot status', error);
  }
};

export const getUserInfiBalance = async (req) => {
  let walletAddress = req;
  let infiAddress = web3config.infiAddress;
  let networkId = web3config.ChainIdMatic;
  let walletProvider = web3config.polygonProvider;
  console.log('infi', infiAddress, networkId, walletProvider);
  try {
    let web3 = new Web3(new Web3.providers.HttpProvider(walletProvider));
    let contract = new web3.eth.Contract(erc20Abi, infiAddress);
    let balance = await contract.methods.balanceOf(walletAddress).call();
    return {
      status: true,
      balance: Number(balance) / 10 ** 18,
    };
  } catch (error) {
    console.log(`Error getting Infi balance for ${walletAddress}`, error);
    return {
      message: error.toString(),
    };
  }
};

export const getTokenPriceSwap = async (req) => {
  try {
    let data = req;
    let results = [];
    for (let i = 0; i < data.length; i++) {
      if (
        !data[i].usdtContract ||
        !data[i].pairContractAddress ||
        !data[i].token_address
      ) {
        results.push(null);
        continue;
      }
      const validate = await validateProvider2(data[i].chainRPCUrl);
      if (!validate.status) {
        return validate;
      }
      let web3 = validate.web3;
      let pairContract = new web3.eth.Contract(
        swapAbi,
        data[i].pairContractAddress
      );
      let contractUsdt = new web3.eth.Contract(erc20Abi, data[i].usdtContract);
      let decimals = await contractUsdt.methods.decimals().call();
      let trx = await pairContract.methods
        .getTokenPriceInUsdt(data[i].token_address)
        .call();
      //console.log('PO',data[i].pairContractAddress,data[i].usdtContract, data[i].token_address)
      let Price =
        Number(trx) /
        10 **
          parseInt(decimals).toLocaleString('fullwide', { useGrouping: false });
      results.push(Price);
    }
    return {
      status: true,
      data: results,
    };
  } catch (error) {
    console.error('Error getting token price', error);
  }
};

const validateProvider2 = async (walletProvider) => {
  //console.log("validateProvider2");
  try {
    if (!walletProvider) {
      // console.log("walletProvider");

      return {
        status: false,
        message: `Please connect your web3 wallet`,
      };
    }
    const web3 = new Web3(walletProvider);

    return {
      status: true,
      web3,
    };
  } catch (error) {
    console.log('Error in validateProvider :', error);
    return {
      status: false,
      message: 'Error in validating provider. Please try again.',
    };
  }
};
